import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'notification'

const initialState = {
  list: null,
  total: null,
  byStatus: null,
  searchLoading: false,
}

export const search = createApiAction('notification/search', client.search('/api/notification/statistics'))
export const save = createApiAction('notification/save', client.save('/api/notification'))

const notificationSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(search.pending, state => {
        state.list = null
        state.searchLoading = true
      })
      // the endpoint answers { total, byStatus, items } — not the usual { rows, count }
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload.items
        state.total = action.payload.total
        state.byStatus = action.payload.byStatus
        state.searchLoading = false
      })
      .addCase(search.rejected, state => {
        state.list = []
        state.total = 0
        state.byStatus = null
        state.searchLoading = false
      })
  },
})

export default notificationSlice.reducer
